<template>
  <div class="card-form">
    <el-row :gutter="10">
      <el-col :span="9">
        <page-dict-table />
      </el-col>
      <el-col :span="15">
        <page-dict-options-table />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import PageDictTable from './components/dict-table'
import PageDictOptionsTable from './components/dict-options-table'
export default {
  name: 'master-bizDictSet',
  components: {
    PageDictTable,
    PageDictOptionsTable
  }
}
</script>
